import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { Identificationtype } from '../../models/User/documentupload/user.documentupload.model';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { Ng2DeviceService } from 'ng2-device-detector';
@Injectable()
export class userdocserviceopp {
  userGioLocation: UserGioLocation;
  constructor(private http: Http, private utilserv: utilityService, private geoloc: geolocation,  private deviceService: Ng2DeviceService) {}
  getcountrydoucmenttypelistrequest(CountryCode: string, TypeName?: string) {
    let param: any;
    if (!this.utilserv.isNull(TypeName)) {
      param = { CountryCode: CountryCode };
    } else {
      param = { CountryCode: CountryCode, TypeName: TypeName };
    }
    // let headers: Headers = new Headers();
    // headers.append('Content-Type', 'application/json; charset=utf-8');
    // let options = new RequestOptions({ headers: headers });
    return this.utilserv.restPost(JSON.stringify(param), AppSettings.ICEMasterService + '/GetIdentificationTypes');
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Promise.reject(errMsg);
  }

  saveuserdocument(document) {
    return this.utilserv.soapPostwithoutAction(this.savedocumentenvolpe(document), AppSettings.ICEDocumentMgmt);
  }
  savedocImage(document) {
    return this.utilserv.soapPostwithoutAction(this.savedocImageEnvolpe(document), AppSettings.ICEDocumentMgmt);
  }

  // getDocumentList() {
  //   return this.utilserv.soapPostwithoutAction(this.getDocumentListEnvelope(),
  //     AppSettings.edituserprofile_doclist_url);

  // }
  //  populateDocumentModel(res: any) {
  //         let lstDocument = new Array<Identificationtype>();
  //         res.forEach(element => {

  //             var utl = new Identificationtype();
  //             utl.TypeName = element.TypeName;
  //             utl.IssuerCountryCode = element.IssuerCountryCode;
  //             utl.IssuerStateCode = element.IssuerStateCode;
  //             utl.BackImage = element.BackImage;
  //             utl.ForBeneficiary = element.ForBeneficiary;
  //             utl.ForCustomer = element.ForCustomer;
  //             utl.RequiresExpirationDate = element.RequiresExpirationDate
  //             utl.ValidCountries = element.ValidCountries;
  //             utl.Masks = element.Masks;
  //             lstDocument.push(utl);
  //         });

  //         return lstDocument;
  //     }

  populateDocumentModelUserEDit(res: any) {
    let lstDocument = new Array<Identificationtype>();
    let DocumentInfoList = this.utilserv.getArray(res.Envelope.Body.DocumentInfoResponse.Documents.DocumentInfo);
    DocumentInfoList.forEach(element => {
      var utl = new Identificationtype();
      utl.TypeName = this.utilserv.getObjectText(element.DocumentType) ;
      utl.IssuerConCode = this.utilserv.getObjectText(element.IssuerCountryCode);
      utl.IssuerStateCode = this.utilserv.getObjectText(element.IssuerStateCode);
      utl.BackImage = this.utilserv.getObjectText(element.BackImage);
      utl.ForBeneficiary = this.utilserv.getObjectText(element.ForBeneficiary);
      utl.ForCustomer = this.utilserv.getObjectText(element.ForCustomer);
      utl.RequiresExpirationDate = this.utilserv.getObjectText(element.RequiresExpirationDate);
      utl.ValidCountries = this.utilserv.getObjectText(element.ValidCountries);
      utl.Masks = element.Masks;
      utl.DocumentNumber = this.utilserv.getObjectText(element.DocumentNumber);
      utl.DocumentType = this.utilserv.getObjectText(element.DocumentType);
      utl.IssuedBy = this.utilserv.getObjectText(element.IssuedBy);
      utl.IsApproved = this.utilserv.getObjectText(element.IsApproved);
      utl.ExpirationDate = this.utilserv.getObjectText(element.ExpirationDate);
      lstDocument.push(utl);
    });

    return lstDocument;
  }

  populateDocumentModelStep1(res: any) {
    let lstDocument = new Array<Identificationtype>();
    res.Identificationtypes.forEach(element => {
      var utl = new Identificationtype();
      utl.TypeName = element.TypeName;
      utl.IsTaxId = element.IsTaxId;
      utl.IssuerConCode = element.IssuerCountryCode;
      utl.IssuerStateCode = element.IssuerStateCode;
      utl.BackImage = element.BackImage;
      utl.ForBeneficiary = element.ForBeneficiary;
      utl.ForCustomer = element.ForCustomer;
      utl.RequiresExpirationDate = element.RequiresExpirationDate;
      utl.ValidCountries = element.ValidCountries;
      utl.Masks = element.Masks;
      utl.Names = element.Names;
      lstDocument.push(utl);
    });

    return lstDocument;
  }

  savedocumentenvolpe(documentmodel): string {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });

    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                          <s:Header>
                            <a:Action s:mustUnderstand="1">http://tempuri.org/IICEDocumentMgmt/SaveDocument</a:Action>
                            <a:MessageID>urn:uuid:7cb82bc7-4ebe-4159-ba58-c6c27013c49b</a:MessageID>
                            <a:ReplyTo>
                              <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                            </a:ReplyTo>
                          </s:Header>
                          <s:Body>
                            <DocumentInfoRequest xmlns="http://tempuri.org/">
                              <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                                <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                                <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                                <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                                <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                                <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                                <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                                <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                                <d4p1:Latitude>${this.userGioLocation.latitude}</d4p1:Latitude>
                                <d4p1:Longitude>${this.userGioLocation.longitude}</d4p1:Longitude>
                                <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                              </DeviceDetails>
                              <DocumentInformation xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.DocumentManagement.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                <d4p1:DocumentID>${documentmodel.DocumentID}</d4p1:DocumentID>
                                <d4p1:DocumentNumber>${this.utilserv.getObjectText(documentmodel.DocumentNumber)}</d4p1:DocumentNumber>
                                <d4p1:DocumentType>${this.utilserv.getObjectText(documentmodel.TypeName)}</d4p1:DocumentType>
                                <d4p1:ExpirationDate>${this.utilserv.getObjectText(documentmodel.ExpirationDate)}</d4p1:ExpirationDate>
                                <d4p1:FrontImage />
                                <d4p1:ImageData i:nil="true"/>
                                <d4p1:ImageType i:nil="true"/>

                                <d4p1:IsApproved>${documentmodel.IsApproved}</d4p1:IsApproved>
                                <d4p1:IssuedBy>${documentmodel.IssuedBy}</d4p1:IssuedBy>
                                <d4p1:IssuerCountryCode>${this.utilserv.getObjectText(documentmodel.IssuerConCode)}</d4p1:IssuerCountryCode>
                                <d4p1:IssuerStateCode>${this.utilserv.getObjectText(documentmodel.IssuerStateCode)}</d4p1:IssuerStateCode>
                                <d4p1:RearImage i:nil="true"/>
                                <d4p1:UploadType>0</d4p1:UploadType>

                               </DocumentInformation>
                              <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                              <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.DocumentManagement.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                 <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                 <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                              </Session>
                            </DocumentInfoRequest>
                          </s:Body>
                        </s:Envelope>`;
    //console.log(envelope);
    return envelope;
  }

  savedocImageEnvolpe(documentmodel) {

    const DeviceDetail = this.deviceService.getDeviceInfo();
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });

    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                            <s:Header>
                              <a:Action s:mustUnderstand="1">http://tempuri.org/IICEDocumentMgmt/UploadFrontRear</a:Action>
                              <a:MessageID>urn:uuid:20f3bf6f-91f5-4c4a-acf2-c2fdece42e0a</a:MessageID>
                              <a:ReplyTo>
                                <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                              </a:ReplyTo>
                            </s:Header>
                            <s:Body>
                              <DocumentInfoRequest xmlns="http://tempuri.org/">
                              <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                                <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                                <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                                <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                                <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                                <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                                <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                                <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                                <d4p1:Latitude>${this.userGioLocation.latitude}</d4p1:Latitude>
                                <d4p1:Longitude>${this.userGioLocation.longitude}</d4p1:Longitude>
                                <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                              </DeviceDetails>
                                <DocumentInformation xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.DocumentManagement.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:DocumentID>${documentmodel.DocumentID}</d4p1:DocumentID>
                                  <d4p1:DocumentNumber>${documentmodel.DocumentNumber}</d4p1:DocumentNumber>
                                  <d4p1:DocumentType>${documentmodel.TypeName}</d4p1:DocumentType>
                                  <d4p1:ImageData>${documentmodel.ImageData}</d4p1:ImageData>
                                  <d4p1:ImageType>${documentmodel.ImageType}</d4p1:ImageType>
                                  <d4p1:UploadType>${documentmodel.UploadType}</d4p1:UploadType>
                                </DocumentInformation>
                                <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                                <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroService.DocumentManagement.Common.Contract" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                 <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                </Session>
                              </DocumentInfoRequest>
                            </s:Body>
                          </s:Envelope>`;
    //console.log(envelope);
    return envelope;
  }


  populateDocumentStep2(element) {
    const utl = new Identificationtype();
    utl.TypeName = element.TypeName;
    utl.IssuerConCode = this.utilserv.getObjectText(element.IssuerConCode);
    utl.IssuerStateCode = this.utilserv.getObjectText(element.IssuerStateCode);
    utl.BackImage = element.BackImage;
    utl.ExpirationDate = element.ExpirationDate;
    utl.IssuedBy = element.IssuedBy;
    utl.DocumentNumber = element.DocumentNumber;
    utl.DocumentType = element.DocumentType;
    utl.DocumentID = this.utilserv.getObjectText(element.DocumentID);
    return utl;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/user.documentupload.service.ts